import React from 'react';
import { DeliveryTierCardProps } from '../../../types';
import { Button, Icon } from '../../atoms';
import './DeliveryTierCard.css';

const DeliveryTierCard: React.FC<DeliveryTierCardProps> = ({
  tier,
  onEdit,
  onDelete,
  className = ''
}) => {
  const handleEdit = () => {
    onEdit(tier);
  };

  const handleDelete = () => {
    onDelete(tier);
  };

  return (
    <div className={`delivery-tier-card ${className} ${!tier.isActive ? 'inactive' : ''}`}>
      <div className="card-header">
        <div className="tier-info">
          <h4 className="tier-name">{tier.name}</h4>
          <div className="tier-status">
            <span className={`status-badge ${tier.isActive ? 'active' : 'inactive'}`}>
              {tier.isActive ? 'Active' : 'Inactive'}
            </span>
          </div>
        </div>
        <div className="card-actions">
          <Button
            variant="primary"
            size="small"
            onClick={handleEdit}
            className="edit-button"
          >
            <Icon type="edit" size="small" />
            Edit
          </Button>
          <Button
            variant="secondary"
            size="small"
            onClick={handleDelete}
            className="delete-button" 
          >
            <Icon type="delete" size="small" />
            Delete
          </Button>
        </div>
      </div>

      <div className="card-content">
        <div className="price-section">
          <div className="price-label">Delivery Price</div>
          <div className="price-value">€{tier.price.toFixed(2)}</div>
        </div>

        <div className="locations-section">
          <div className="locations-header">
            <span className="locations-label">Assigned Locations</span>
            <span className="locations-count">({tier.locations.length})</span>
          </div>
          
          {tier.locations.length === 0 ? (
            <div className="no-locations">
              <Icon type="error" size="small" />
              <span>No locations assigned</span>
            </div>
          ) : (
            <div className="locations-list">
              {tier.locations.slice(0, 3).map(location => (
                <div key={location.town} className="location-item">
                  <span className="location-town">{location.town}</span>
                  <span className="location-routing">({location.routingKey})</span>
                </div>
              ))}
              {tier.locations.length > 3 && (
                <div className="more-locations">
                  +{tier.locations.length - 3} more location{tier.locations.length - 3 !== 1 ? 's' : ''}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="card-footer">
        <div className="tier-meta">
          <span className="created-date">
            Created: {tier.createdAt.toLocaleDateString()}
          </span>
          {tier.updatedAt.getTime() !== tier.createdAt.getTime() && (
            <span className="updated-date">
              Updated: {tier.updatedAt.toLocaleDateString()}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryTierCard;
